export class ModalButtonModel {
	public name?: string;
	public text?: string;
	public icon?: string;
	public tooltipText?: string;
	public type?: ModalButtonType;
	public show?: () => boolean;
	public active?: () => boolean;
	public disabled?: () => boolean;
	public action?: () => any;
	public loading?: () => boolean;
	public loadingText?: string;
	class?: string;
}

export enum ModalButtonType {
	ACTION = 'action'
}
